import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import NotificationsPanel from "./NotificationsPanel";

/**
 * NotificationsMobileDrawer — the full-screen notifications panel portalled
 * to document.body on phone widths (< 640px), the same treatment
 * MoreToolsMobileDrawer uses for the more-tools menu, so a narrow viewport
 * never has to fit a fixed-width popover.
 */
const NotificationsMobileDrawer = ({
  isDark,
  onClose,
  count,
  loading,
  markAllRead,
  notifications,
  fetchLoading,
  handleOpenNotification,
  handleViewAll,
}) => {
  const { t } = useTranslation();

  return createPortal(
    <div
      className={`sm:hidden fixed inset-0 z-[99999] flex flex-col ${
        isDark ? "bg-chrome text-surface" : "bg-surface text-heading"
      } animate-in fade-in duration-200`}
    >
      <div
        className={`flex items-center justify-between px-5 py-4 border-b shrink-0 ${
          isDark ? "border-white/[0.08]" : "border-border-light"
        }`}
      >
        <span className="font-bold text-base">
          {t("settings.notifications")}
        </span>
        <button
          type="button"
          onClick={onClose}
          className={`w-9 h-9 rounded-full flex items-center justify-center transition-colors border-0 cursor-pointer ${
            isDark
              ? "bg-white/[0.08] hover:bg-white/[0.15] text-white"
              : "bg-surface-muted hover:bg-gray-200 text-heading"
          }`}
          aria-label="Close"
        >
          <FontAwesomeIcon icon={faXmark} className="text-base" />
        </button>
      </div>

      <NotificationsPanel
        t={t}
        count={count}
        loading={loading}
        markAllRead={markAllRead}
        notifications={notifications}
        fetchLoading={fetchLoading}
        handleOpenNotification={handleOpenNotification}
        handleViewAll={handleViewAll}
        showTitle={false}
        listClassName="flex-1 overflow-y-auto"
      />
    </div>,
    document.body
  );
};

export default NotificationsMobileDrawer;
